import { FlightTextArea } from '@flybits/design-system';
import React, { useState } from 'react';
import { FieldsConfig } from 'src/model/connectors/connectors';
import ItemHeader from '../ItemHeader/ItemHeader';
import './TextareaPreview.scss';

const TextareaPreview = (props: FieldsConfig) => {
  const { name, onChangeValue, configField } = props;
  const [value, setValue] = useState(configField ? configField[2]?.configVal : '');
  const handleChange = (e: any) => {
    setValue(e.target.value);
    typeof onChangeValue === 'function' &&
      onChangeValue({
        field: [configField[0], configField[1]],
        data: { ...configField[2], configVal: e.target.value },
      });
  };
  return (
    <>
      <ItemHeader {...props} />
      <div>
        <FlightTextArea
          hideCharCounter={true}
          label=""
          width="400px"
          name={name}
          value={value}
          onChange={handleChange}
          data-lpignore="true"
        />
      </div>
    </>
  );
};
export default TextareaPreview;
